import React from "react";
import FavoriteIcon from "@material-ui/icons/Favorite";
import "./styles.css";

const favoriteText = "FAVORITE";
const defavoriteText = "MARK AS FAVORITE";

export const FavoriteButton = ({ isFavorite, onClick }) => (
  <div className="supervised-analysis-favorite-wrapper">
    <FavoriteIcon onClick={() => onClick()} style={{ cursor: "pointer", color: (isFavorite) ? "#0F9AD6" : "" }} />
    <p style={{ "margin-top": 0, "margin-bottom": 0 }}>{isFavorite ? favoriteText : defavoriteText}</p>
  </div>
);
